



















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, OptionItemType } from '../../types/type'
import { CanteenModule } from '../../store'
import { Pagination } from '../../mixins/pagination'
import { findItemForTree, getNameTextInOptions } from '../../utils/toolsForCommon'
import DateUtil from '../../utils/toolsForDate'
declare interface DaysType {
  dayOfFull: string
  day: number
  isSelectMonth: boolean
  position: string
}
declare interface MonthsType {
  monthOfFull: string
  month: string
}
@Component({
  name: 'EarlyWarningConfig',
  mixins: [Pagination],
  components: {
    'my-table': () => import('../../components/common/myTable/index.vue'),
    'empty-container': () => import('../../components/empty.vue')
  }
})
export default class EarlyWarningConfig extends Vue {
  public loading: boolean = false
  public paneName: string = 'earlyWarningConfig'
  // 预警项目配置相关：
  // 列表列有哪些：
  // public earlyWarningConfigTitleList: Array<TableColumnItemType> = [
  //   {
  //     title: '预警类型',
  //     key: 'type',
  //     flex: 1
  //   },
  //   {
  //     title: '年月日',
  //     key: 'yearMonthDay',
  //     flex: 1
  //   },
  //   {
  //     title: '是否跳过',
  //     key: 'isSkip',
  //     flex: 1
  //   },
  //   {
  //     title: '是否启用',
  //     key: 'isActive',
  //     flex: 1
  //   },
  //   {
  //     title: '操作',
  //     key: 'operationInTable',
  //     flex: 1,
  //     width: '160px'
  //   }
  // ]
  public loadingForEarlyWarningConfig = false
  // 列表内容有哪些：
  // public earlyWarningConfigBodyList: Array<any> = []
  // 列表每一行的操作有哪些：
  // public columnOperationListForEarlyWarningConfigBodyList: Array<OperationItemType> = [
  //   {
  //     title: '启用',
  //     key: 'startUsingForEarlyWarningConfig',
  //     type: 'success',
  //     size: 'mini'
  //   },
  //   {
  //     title: '停用',
  //     key: 'stopUsingForEarlyWarningConfig',
  //     type: 'warning',
  //     size: 'mini'
  //   },
  //   {
  //     title: '删除',
  //     key: 'delete',
  //     type: 'danger',
  //     size: 'mini'
  //   }
  // ]
  // 枚举选项：
  public optionsForType: Array<OptionItemType> = [
    {
      name: '食材支出占比',
      value: 1
    },
    {
      name: '食材单价',
      value: 2
    },
    {
      name: '自制凭证',
      value: 3
    },
    {
      name: '日常预警',
      value: 4
    },
    {
      name: '流水',
      value: 5
    }
  ]
  public optionsForSubType: Array<OptionItemType> = [
    {
      name: '陪餐',
      value: 1
    },
    {
      name: '培训',
      value: 2
    },
    {
      name: '留样',
      value: 3
    },
    {
      name: '消杀',
      value: 4
    }
  ]
  // public pageSize: number = 20
  // 搜索相关：
  public typeForSearch: number | string = ''
  public subTypeForSearch: number | string = ''
  // public yearForDate: string = ''
  // public monthForDate: string = ''

  // 自定义日历相关：
  public weeks: Array<string> = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  public selectMonth = '' // 所选月份
  public daysForSelectMonth: Array<DaysType> = [] // 所选月份天数
  public weekDayForSelectMonthOfTheFirstDay: number | string = '' // 所选月份的1号是星期几
  public selectDay = '' // 所选的日期

  // 自定义月份相关：
  public months: Array<string> = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
  public selectYear = '' // 所选年份
  public monthsForSelectYear: Array<MonthsType> = []
  public selectMonthForMonthList = ''

  get today () {
    return DateUtil.getNowDay()
  }

  get currentMonthList () {
    let currentMonthList = []
    currentMonthList = this.selectMonth.split('-')
    return currentMonthList
  }

  get myCalendarContainerShow () {
    let flag = false
    if (this.typeForSearch === 4) {
      switch (this.subTypeForSearch) {
        case 1:
        case 3:
        case 4:
          flag = true
          break
      }
    }
    if (this.typeForSearch === 2) {
      flag = true
    }
    return flag
  }

  get monthListContainerShow () {
    let flag = false
    switch (this.typeForSearch) {
      case 1:
      case 3:
      case 5:
        flag = true
        break
      case 4:
        if (this.subTypeForSearch === 2) {
          flag = true
        }
        break
    }
    return flag
  }

  async mounted () {
    this.calendarInit()
    this.monthsForSelectYearInit()
    // this.getTableDataList()
  }

  calendarInit () {
    this.selectMonth = this.today.slice(0, 7)
    this.getDayAndWeek()
    this.selectDay = this.today
  }

  monthsForSelectYearInit () {
    this.selectYear = this.today.slice(0, 4)
    this.getMonths()
    this.selectMonthForMonthList = this.today.slice(0, 7)
  }

  getMonths () {
    this.monthsForSelectYear = new Array(12).fill(0).map((item, index) => {
      item = {
        monthOfFull: `${this.selectYear}-${(index + 1).toString().padStart(2, '0')}`,
        month: this.months[index]
      }
      return item
    })
  }

  // 获取所选月份的天数和一号是星期几
  getDayAndWeek () {
    const date = new Date(this.selectMonth)
    let daysForSelectMonthReal = []
    // 一号是星期几
    const weekDayForSelectMonthOfTheFirstDay = new Date(`${date}-1`).getDay()
    // 头部补位：
    let daysBefore = new Array(weekDayForSelectMonthOfTheFirstDay).fill({
      dayOfFull: '',
      day: '',
      isSelectMonth: false,
      position: 'before'
    })
    // 获取天数：
    const days = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    let dayCenter = new Array(days).fill(0).map((item, index) => {
      item = {
        dayOfFull: `${this.selectMonth}-${(index + 1).toString().padStart(2, '0')}`,
        day: (index + 1) + '日',
        isSelectMonth: true,
        position: 'center'
      }
      return item
    })
    const daysOfBeforeAndCenter = [...daysBefore, ...dayCenter]
    if (daysOfBeforeAndCenter.length < 42) {
      daysForSelectMonthReal = daysOfBeforeAndCenter.concat((new Array(42 - daysOfBeforeAndCenter.length).fill({
        dayOfFull: '',
        day: '',
        isSelectMonth: false,
        position: 'after'
      })))
    } else {
      daysForSelectMonthReal = daysOfBeforeAndCenter
    }
    this.daysForSelectMonth = daysForSelectMonthReal
  }

  // 切换月
  operationForChangeTheSelectMonth (operationType: number): void {
    const date = new Date(this.selectMonth)
    let selectMonth = ''
    switch (operationType) {
      case 1:
        selectMonth = date.getMonth() ? `${date.getFullYear()}-${date.getMonth().toString().padStart(2, '0')}` : `${date.getFullYear() - 1}-12`
        break
      case 2:
        selectMonth = date.getMonth() === 11 ? `${date.getFullYear() + 1}-01` : `${date.getFullYear()}-${(date.getMonth() + 2).toString().padStart(2, '0')}`
        break
    }
    this.selectMonth = selectMonth
    this.getDayAndWeek()
    this.getTableDataList()
  }

  // 点击今天：
  operationForGoToday () {
    this.calendarInit()
    this.getTableDataList()
  }

  // 选中天：
  operationForSelectDay (item: DaysType) {
    if (!item.isSelectMonth) return
    this.selectDay = item.dayOfFull
  }

  // 切换年：
  operationForChangeTheSelectYear (operationType: number): void {
    const date = new Date(this.selectYear)
    let selectYear = ''
    switch (operationType) {
      case 1:
        selectYear = `${date.getFullYear() - 1}`
        break
      case 2:
        selectYear = `${date.getFullYear() + 1}`
        break
    }
    this.selectYear = selectYear
    this.getMonths()
    this.getTableDataList()
  }

  // 点击当月：
  operationForGoCurrentMonth () {
    this.monthsForSelectYearInit()
    this.getTableDataList()
  }

  // 选中月：
  operationForSelectMonth (item: MonthsType) {
    this.selectMonthForMonthList = item.monthOfFull
  }

  changeForTypeForSearch () {
    this.getTableDataList()
  }

  changeForSubTypeForSearch () {
    this.getTableDataList()
  }

  // changeForYearForDate () {

  // }

  // changeForMonthForDate () {

  // }

  async getTableDataList () {
    try {
      if (!this.myCalendarContainerShow && !this.monthListContainerShow) return
      const _that: any = this
      const params = {
        type: this.typeForSearch
      }
      if (this.typeForSearch === 4) {
        Object.assign(params, {
          subType: this.subTypeForSearch
        })
      }
      if (this.myCalendarContainerShow) {
        const arr = this.selectMonth.split('-')
        Object.assign(params, {
          year: arr[0],
          month: arr[1]
        })
      }
      if (this.monthListContainerShow) {
        Object.assign(params, {
          year: this.selectYear,
          month: ''
        })
      }
      // console.log(params)
      this.loadingForEarlyWarningConfig = true
      const { data: result } = await (this as any).$http.warningConfigQueryCalendar(params)
      this.loadingForEarlyWarningConfig = false
      if (result.code !== 200) return this.$message.error(result.msg)
      if (this.myCalendarContainerShow) {
        // console.log(result.data.day, 'day')
        // console.log(this.daysForSelectMonth, 'daysForSelectMonth')
        let map = new Map()
        ;(result.data.day || []).forEach(item => {
          map.set(item.date, item)
        })
        this.daysForSelectMonth = this.daysForSelectMonth.map(item => {
          if (map.get(item.dayOfFull)) {
            return {
              ...item,
              ...map.get(item.dayOfFull)
            }
          } else {
            return {
              ...item
            }
          }
        })
        // console.log(this.daysForSelectMonth, 'this.daysForSelectMonth')
      }
      if (this.monthListContainerShow) {
        // console.log(result.data.month, 'month')
        // console.log(this.monthsForSelectYear, 'monthsForSelectYear')
        let map = new Map()
        ;(result.data.month || []).forEach(item => {
          map.set(item.date, item)
        })
        this.monthsForSelectYear = this.monthsForSelectYear.map((item, index) => {
          if (map.get(item.monthOfFull)) {
            return {
              ...item,
              ...map.get(item.monthOfFull)
            }
          } else {
            return {
              ...item
            }
          }
        })
        // console.log(this.monthsForSelectYear, 'this.monthsForSelectYear')
      }
      // _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
      //   // item.certificate = item.certificate ? item.certificate.split(',') : []
      //   if (item.type === 4) {
      //     item.type = getNameTextInOptions(this.optionsForType, item.type) + '(' + getNameTextInOptions(this.optionsForSubType, item.subType) + ')'
      //   } else {
      //     item.type = getNameTextInOptions(this.optionsForType, item.type)
      //   }
      //   item['yearMonthDay'] = (item.year ? item.year : '暂无') + '-' + (item.month ? item.month : '暂无') + '-' + (item.day ? item.day : '暂无')
      //   item.isSkip = item.isSkip ? '是' : '否'
      //   item.isActive = item.isActive ? '是' : '否'
      //   return item
      // })
      // this.earlyWarningConfigBodyList = _that.tableDataList
      // _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  // 操作按钮：
  // operationForButton ({ key }, row) {
  //   const { id } = row
  //   switch (key) {
  //     case 'startUsingForEarlyWarningConfig':
  //     case 'stopUsingForEarlyWarningConfig':
  //       this.operationForStartUsingOrStopUsing(id, key)
  //       break
  //     case 'delete':
  //       this.operationForDelete(id)
  //       break
  //   }
  // }

  // operationForStartUsingOrStopUsing (id: string, type: string) {
  //   let operationType = ''
  //   switch (type) {
  //     case 'startUsingForEarlyWarningConfig':
  //       operationType = '启用'
  //       break
  //     case 'stopUsingForEarlyWarningConfig':
  //       operationType = '停用'
  //       break
  //   }
  //   this
  //     .$confirm(`确定要${operationType}此预警吗?`, '提示', {
  //       confirmButtonText: `确定${operationType}`,
  //       cancelButtonText: `取消${operationType}`,
  //       type: 'warning'
  //     })
  //     .then(async () => {
  //       const params = {
  //         id,
  //         isActive: type === 'startUsingForEarlyWarningConfig' ? true : false
  //       }
  //       let { data: result } = await (this as any).$http.warningConfigActive(params)
  //       if (result.code !== 200) return this.$message.error(result.msg)
  //       this.$message.success(`${operationType}成功！`)
  //       this.getTableDataList()
  //     })
  //     .catch(() => {})
  // }

  // 删除：
  // operationForDelete (id: string) {
  //   this
  //     .$confirm('确定要删除此预警吗?', '提示', {
  //       confirmButtonText: '确定删除',
  //       cancelButtonText: '取消删除',
  //       type: 'error'
  //     })
  //     .then(async () => {
  //       let { data: result } = await (this as any).$http.warningConfigDelById({ id })
  //       if (result.code !== 200) return this.$message.error(result.msg)
  //       this.$message.success('删除成功！')
  //       this.getTableDataList()
  //     })
  //     .catch(() => {})
  // }

  beforeLeave (activeName: string): void {
    this.$router.replace({ name: 'EarlyWarningConfig', query: { paneName: activeName } })
    this.paneName = activeName
    this.getDateForWho()
  }

  getDateForWho () {
    switch (this.paneName) {
      case 'earlyWarningConfig':
        this.getTableDataList()
        break
    }
  }

  // operationForAddOrUpdate (id: string) {
  //   this.$router.push({
  //     name: 'AddOrUpdateEarlyWarning',
  //     query: {
  //       id
  //     }
  //   })
  // }

  // operationForClickOfAddEarlyWarning () {
  //   this.operationForAddOrUpdate('add')
  // }

  addOrUpdateWarningConfigForMonth (item, dayOrMonth, neddOrNoNeed, text) {
    this
      .$confirm(`确定要${text}吗?`, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      })
      .then(async () => {
        const params = {
          type: this.typeForSearch,
          isActive: true
        }
        if (this.typeForSearch === 4) {
          Object.assign(params, {
            subType: this.subTypeForSearch
          })
        }
        switch (dayOrMonth) {
          case 'day':
            Object.assign(params, {
              year: item.dayOfFull.split('-')[0],
              month: item.dayOfFull.split('-')[1],
              day: item.dayOfFull.split('-')[2]
            })
            break
          case 'month':
            Object.assign(params, {
              year: item.monthOfFull.split('-')[0],
              month: item.monthOfFull.split('-')[1]
            })
            break
        }
        switch (neddOrNoNeed) {
          case 'need':
            Object.assign(params, {
              isSkip: false
            })
            break
          case 'noNeed':
            Object.assign(params, {
              isSkip: true
            })
            break
        }
        const { data: result } = await (this as any).$http.warningConfigAdd(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success(`操作成功`)
        this.getTableDataList()
      })
      .catch(() => {})
  }
}
